<div class="status-cell-container">
	<div class="circle" *ngIf='!isNumberFlag' [ngClass]="{'circle_active': !flag,'circle_disabled': flag}"></div>
	<div class="circle" *ngIf='isNumberFlag' [ngClass]="{'circle_active': flag === 1,'circle_disabled': flag === 2,'circle_pending': flag === 0}"></div>
	{{ value }}
</div>
